import React from "react";
import ProjetoLayout from "../componentes/ProjetoLayout";

function AssistenteImobiliario() {
  return (
    <ProjetoLayout
      titulo="Assistente Inteligente Imobiliário"
      tagline="Ecossistema full-stack de atendimento e triagem automatizada com IA para o setor imobiliário de alto padrão — em operação real."
      capa="/capa-assistente.png"
      capaAlt="Assistente Inteligente Imobiliário"
      tags={[
        "Node.js",
        "Next.js",
        "Prisma ORM",
        "PostgreSQL",
        "n8n",
        "WhatsApp API",
        "Business Intelligence",
        "TypeScript",
        "Tailwind CSS",
      ]}
      meta={[
        { ic: "code", label: "Tipo", value: "Full-stack + IA" },
        { ic: "role", label: "Status", value: "Em operação real" },
        { ic: "local", label: "Setor", value: "Imobiliário" },
      ]}
    >
      <h2>Engenharia de dados e automação em escala real</h2>
      <p>
        Este projeto não é apenas um chatbot; é um{" "}
        <strong>ecossistema corporativo completo</strong> que gerencia a porta de
        entrada de uma grande empresa do setor imobiliário. O sistema está em{" "}
        <strong>operação real</strong>, processando interações de clientes e
        corretores parceiros com alta precisão.
      </p>
      <p>
        O foco principal foi criar uma arquitetura onde a Inteligência Artificial
        atua como uma camada de interface para um{" "}
        <strong>banco de dados SQL completo</strong>. O sistema identifica a
        necessidade do usuário, consulta a base em tempo real e entrega
        informações técnicas detalhadas que antes exigiriam intervenção humana
        manual.
      </p>

      <h3>Estrutura e diferenciais técnicos</h3>
      <ul>
        <li>
          <strong>Triagem e fluxos especializados:</strong> algoritmos de
          classificação identificam o perfil do usuário (cliente ou corretor) e o
          motor de regras direciona o atendimento para fluxos de dados distintos.
        </li>
        <li>
          <strong>Interação com base de dados (RAG):</strong> consulta dinâmica
          por tipologias, bairros ou características, retornando a ficha técnica
          detalhada direto do banco, sempre atualizada.
        </li>
        <li>
          <strong>Portal de gestão e BI:</strong> interface administrativa com
          monitoramento em tempo real e dashboards de insights sobre imóveis mais
          procurados e comportamento dos leads.
        </li>
        <li>
          <strong>Integração com a agenda do corretor:</strong> via API do Google
          Agenda, verifica disponibilidade e envia a solicitação de aceite ao
          WhatsApp do corretor.
        </li>
        <li>
          <strong>Integração com o CRM:</strong> cada interação e dado captado é
          registrado automaticamente no CRM, eliminando entrada manual.
        </li>
        <li>
          <strong>API oficial do Meta (WhatsApp):</strong> todo o sistema foi
          integrado à API oficial para maior segurança dos dados dos usuários.
        </li>
      </ul>

      <h3>Transbordo humano inteligente</h3>
      <p>
        Caso o sistema detecte uma incapacidade técnica ou uma oportunidade de
        fechamento imediato, ele aciona automaticamente os consultores via
        webhook, enviando o histórico completo da conversa para que o atendimento
        humano continue exatamente de onde a IA parou.
      </p>
    </ProjetoLayout>
  );
}

export default AssistenteImobiliario;
